<template>
    <div>
        <MobileHeader active="about"></MobileHeader>

        <div>
            <el-row>
                <h1>关于我们</h1>
            </el-row>
        </div>
        <div style="padding-top: 10px; margin-bottom: 40px;">
            <div style="position: relative;">
                <div style="position: relative;">
                    <img :src="aboutBg" style="width:100%;height:200px;" />
                    <i class="el-icon-caret-top" style="font-size: 90px;margin-top: -55px;color: white;"></i>
                </div>

            </div>
            <div class="">
                <div class="" style="margin:10px 20px 10px 20px">
                    <el-row>
                        <h1 class="">公司简介</h1>
                    </el-row>
                </div>
            </div>
            <div class="" style="margin: 0 20px 0 20px">
                <div class="business-content">
                    <div class="duan">
                        长春市三合通科技有限责任公司是由净月高新区政府牵头、联合行业头部企业科大讯飞及专业人士共同出资组建的混合所有制高科技公司，总部位于长春市净月开发区净月影视文化创意产业园5号楼A区6层。
                    </div>
                    <div class="duan">
                        公司设定了“13167”战略蓝图，即“1个目标、3个领域、1个平台、6个能力、7项业务”，1个目标即成为智慧产业应用专家；3个领域即智慧农业、智能装备和智慧城市；1个平台即三产融合大数据平台“三合通云”；6个能力即系统设计能力、基础建设能力、应用运营能力、系统集成能力、科技创新能力以及大数据聚合与管理能力；7项业务即技术咨询服务、系统集成工程、智慧应用工程、大数据服务、软件开发与服务、智能装备研发、工业互联网应用。
                    </div>
                    <div class="duan">
                        基于“符合客户要求、契合技术趋势、联合产业资源”的经营理念，公司先后与中国移动、中国联通、西部产业园、旭阳集团、吉林农业大学、山东理工大学等建立了合作伙伴关系，成为国家精准农业航空施药技术国际联合研究中心产学研合作基地。
                    </div>
                    <div class="duan">
                        围绕主营业务，公司形成了一系列基于5G+AI的自主产品解决方案，包括智慧农业整体解决方案（智慧农业综合管理云服务平台）、无人驾驶技术解决方案（智能行走装备监控服务系统）、智慧旅游解决方案（全域旅游云服务-数据仓库分析系统）、智能制造解决方案、智慧园区建设解决方案等，获得相关软件著作权49项。在农业全过程无人作业试验区建设方面同车联（TIAA）紧密合作；在生态无人农场建设领域与山东理工大学生态无人农场研究院共同开发了生态无人农场云端大脑产品。在智慧城市领域主要与科大讯飞、北京百分点形成战略合作，提供城市大脑解决方案。
                    </div>
                    <div class="duan">
                        在履行社会责任上，公司积极响应党和政府的号召，特别是在此次抗击新冠肺炎疫情当中，主动担当社会责任，参与“心系贫困户，携手抗疫情”活动，向贫困户捐赠1.5万只口罩，为抗击疫情贡献一份力量。
                    </div>
                    <div class="duan">
                        面向未来，三合通科技以“让社会更智慧，让生活更美好”为使命，发扬勇于挑战，敢于创造的企业精神，立足净月、迈向全国、走向世界。
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 60px;">
                <div class="" style="margin:60px 20px 10px 20px">
                    <el-row>
                        <h1 class="">董事长致辞</h1>
                    </el-row>
                </div>
                <div>
                    <img src="../../assets/imgs/about/leader-bak.png" style="width: 100%; height: auto;" />
                </div>
                <div class="business-content" style="margin: 20px 20px 0 20px">
                    <div class="duan">
                        感谢每一位关心、关注三合通科技的朋友和伙伴，三合通科技在长春市、净月开发区政府、社会各界朋友及各位伙伴的支持下于2020年4月29日正式成立了，这是个充满朝气和活力的新生命体，是奋斗者、实干家、挑战者和创造者用智慧谱写美好人生的舞台，三合通科技倡导“天和、人和、心和”下的生态协同；倡导员工自主管理，笃信人心齐泰山移；立志成为知名的智慧产业应用专家；实现“立足净月、迈向全国、走向世界”的梦想。
                    </div>
                    <div class="duan">
                        “勇于挑战、敢于创造”是我们的企业精神，我们坚信只要勇于挑战，就会把不可能变成可能；只要敢于创造，梦想就会变成现实；只要坚定了这样的信念，未来就一定属于我们！ </div>
                    <div class="duan">
                        “智会三合，通达四海”，为践行“让社会更智慧、让生活更美好”的使命，让我们共同携手、共创共享，共生共赢，共同谱写人生绚丽篇章！
                    </div>
                    <el-row>
                        <el-col :span="7">
                            <div style="height: 10px; width: 100%;"></div>
                        </el-col>
                        <el-col :span="7">
                            <p style="color: #2c3e50; font-size: 18px;">董事长：</p>
                        </el-col>
                        <el-col :span="10">
                            <img class="leader" :src="leaderSign" />
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div>
                <div class="" style="margin:60px 20px 10px 20px">
                    <el-row>
                        <h1 class="">愿景与文化</h1>
                    </el-row>
                </div>
            </div>
            <div style="position:relative;top:40px;width: 90%; margin: 0 auto;" class="content">
                <div class="title margin-bottom">
                    <div class="business-content">
                        <div class="text-orange text-bold">公司愿景</div>
                    </div>
                    <div class="business-content padding-bottom margin-bottom solids-bottom">
                        <div class="text-black ">成为知名的智慧产业应用专家</div>
                    </div>
                </div>
                <div class="title margin-bottom">
                    <div class="business-content">
                        <div class="text-orange text-bold">公司使命</div>
                    </div>
                    <div class="business-content padding-bottom margin-bottom solids-bottom">
                        <div class="text-black ">让社会更智慧、让生活更美好</div>
                    </div>
                </div>
                <div class="title margin-bottom">
                    <div class="business-content">
                        <div class="text-orange text-bold">企业精神</div>
                    </div>
                    <div class="business-content padding-bottom margin-bottom solids-bottom">
                        <div class="text-black">勇于挑战，敢于创造</div>
                    </div>
                </div>

                <div class="title margin-bottom posiup">
                    <div class="business-content">
                        <div class="text-orange text-bold">经营理念</div>
                    </div>
                    <div class="business-content padding-bottom margin-bottom solids-bottom  solids-bottom">
                        <div class="text-black">符合客户要求、契合技术趋势、联合产业资源</div>
                    </div>
                </div>
                <div class="title posiup">
                    <div class="business-content">
                        <div class="text-orange text-bold">核心价值观</div>
                    </div>
                    <div class="business-content padding-bottom margin-bottom solids-bottom">
                        <div class="text-black">坚持、创新、奋斗、分享</div>
                    </div>
<!--                    <div class="business-content padding-bottom margin-bottom solids-bottom">-->
<!--                        <div class="text-black">认真干事、激情干事、快乐干事、健康干事</div>-->
<!--                    </div>-->
                </div>
                <div class="title margin-bottom posiup">
                    <div class="business-content">
                        <div class="text-orange text-bold">干事原则</div>
                    </div>
                    <div class="business-content padding-bottom margin-bottom solids-bottom  solids-bottom">
                        <div class="text-black">认真干事、激情干事、快乐干事、健康干事</div>
                    </div>
                </div>

                <div class="title posiup" style="margin-bottom: 60px;">
                    <div class="business-content">
                        <div class="text-orange text-bold">人才观</div>
                    </div>
                    <div class="business-content padding-bottom   solids-bottom">
                        <div class="text-black">想干事、能干事、干实事、干成事，就是人才</div>
                    </div>

                </div>

            </div>
        </div>
        <MobileFooter></MobileFooter>
    </div>
</template>

<script>
    import {global} from "../../utils/global";
    import MobileHeader from "../../components/MobileHeader";
    import MobileFooter from "../../components/MobileFooter";
    export default {
        name: "MobileAbout",
        components: {MobileFooter,MobileHeader},
        data () {
            return {
                aboutBg: global.RESOURCE_PREFIX + '/images/关于我们01.jpg',
                leaderSign: global.RESOURCE_PREFIX + '/images/leader-sign.jpg'
            }
        }
    }
</script>

<style scoped>
    .san1 {
        width: 150px;
        height: 150px;
        position: absolute;
        top: 375px !important;
        left: 400px !important;
        z-index: 8888;
    }

    .text-xxl {
        font-size: 50px;
        text-align: center;
    }

    .title1 {
        font-size: 40px;

    }

    .content {
        font-size: 30px;

    }

    .duan {
        text-indent: 2em;
        text-align: justify;
        text-justify: inter-ideograph;

    }

    .title {
        width: 99%;
    }

    .leader {
        width: 100%;
        height: auto;
    }

    .t {
        position: relative;
        width: 58vw;
        margin-top: 70px;
    }

    .f {
        position: absolute;
        text-align: right;
        margin-bottom: 400px;
    }

    .p {
        position: absolute;
        margin-top: -70px;
        margin-left: 60vw;

    }

    .posi {
        position: absolute;
        top: 1300px;
        z-index: 1024;
    }

    .posiup {
        z-index: 2048;
    }

    .last {
        background-color: white;
        background-color: rgba(255, 255, 255, 0.4);
        width: 92%;
        margin-left: 4%;
        /* opacity: 0.2; */

    }

    .business-content {
        color: grey;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
    }

    .padding-bottom{
        padding-bottom: 15px;
    }

    .title-color{
        color: orange;
    }



</style>
